import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getWrapperClasses = ({ dsf_error }) => {
  const wrapperClasses = [
    "flex",
    "flex-auto",
    "items-center",
    "gap-8",
    "rounded-m",
    "border",
    "p-12",
    "h-64"
  ];
  wrapperClasses.push(dsf_error ? "border-error-300" : "border-neutral-100");
  return concatClasses(wrapperClasses);
};
const getMessageClasses = ({ dsf_error }) => {
  const messageClasses = ["dsf-text-xxs"];
  messageClasses.push(dsf_error ? "text-error-300" : "text-neutral-400");
  return concatClasses(messageClasses);
};
export {
  getMessageClasses,
  getWrapperClasses
};
